import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=5cdf6d9c"
import script from "./alerts.vue?vue&type=script&lang=js"
export * from "./alerts.vue?vue&type=script&lang=js"
import style0 from "./alerts.vue?vue&type=style&index=0&id=5cdf6d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports